<template>
  <div class="portal">
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <h2 class="mb-3">پرداخت ها</h2>
        <v-card class="text-center pa-4">
          <v-card-title>گزارش آخرین پرداخت ها</v-card-title>
          <div class="pa-3">
            <div v-if="portal">
              جناب آقای / سرکار خانم
              <strong>{{ portal.user.firstname }}</strong>
              <strong> {{ portal.user.lastname }}</strong>
              رابط محترم پورتال
              <strong>{{ portal.name }}</strong>
              ؛ خریدهای آخر پورتال شما به شرح زیر می باشد:
            </div>
            <v-alert v-if="info" outlined type="info" class="mt-6 pa-2">
              به صورت پیش فرض 100 پرداخت آخر پروتال شما نمایش داده می شود
            </v-alert>
            <v-row class="my-3">
              <v-col cols="12" md="4">
                <v-text-field
                  id="pStartDate"
                  label="تاریخ شروع"
                  v-model="pStartDate"
                  hide-details="auto"
                />

                <date-picker
                  v-model="pStartDate"
                  :auto-submit="true"
                  format="jYYYY/jMM/jDD"
                  element="pStartDate"
                  alt-name="startDate"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  id="pEndDate"
                  label="تاریخ پایان"
                  v-model="pEndDate"
                  hide-details="auto"
                />

                <date-picker
                  v-model="pEndDate"
                  :auto-submit="true"
                  format="jYYYY/jMM/jDD"
                  element="pEndDate"
                  alt-name="endDate"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-btn depressed block color="primary" @click="updateData">
                  جستجو
                </v-btn>
              </v-col>
            </v-row>

            <v-alert v-if="error" type="error">
              {{ error }}
            </v-alert>

            <v-data-table
              v-else
              dense
              :items="payments"
              :headers="headers"
              :items-per-page="20"
              :loading="loading"
              item-key="_id"
              loading-text="در حال ساخت گزارش ..."
              class="mt-5 px-3 text-no-wrap"
            >
              <template v-slot:[`item.verifyDateTime`]="{ item }">
                <persian-date :date="item.verifyDateTime" />
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "payments-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      info: true,
      loading: true,
      error: null,
      headers: [
        { text: "نام", align: "center", value: "user.firstname" },
        { text: "نام خانوادگی", align: "center", value: "user.lastname" },
        { text: "کتاب", align: "center", value: "book.title" },
        { text: "قیمت", align: "center", value: "finalAmount" },
        { text: "تاریخ خرید", align: "center", value: "verifyDateTime" }
      ],
      portal: null,
      payments: [],
      pStartDate: "",
      pEndDate: ""
    };
  },
  created() {
    this.handleGetDiscountCodes();
  },
  methods: {
    handleGetDiscountCodes() {
      this.loading = true;
      this.$api.get("/payments/portal/reports").then((res) => {
        this.portal = res.data.portal;
        this.payments = res.data.payments;
        this.loading = false;
      });
    },
    updateData() {
      const startDate = document.getElementsByName("startDate")[0].value;
      const endDate = document.getElementsByName("endDate")[0].value;
      this.loading = true;
      this.info = false;
      this.error = null;
      this.$api
        .post("/payments/portal/reports", {
          startDate: startDate,
          endDate: endDate
        })
        .then((res) => {
          if (res.status === 203) {
            this.error = res.data.error;
          } else {
            this.portal = res.data.portal;
            this.payments = res.data.payments;
          }
          this.loading = false;
        });
    }
  }
};
</script>
